const ROOT = "videoPlayer";
const ADD_URL_MODAL = "videoMediaUrlModal";
const ADD_URL_MODAL_INPUT = "videoMediaUrlModalInput";
const ADD_URL_MODAL_SUBMIT = "actionButtonSave";
const ADD_CUSTOM_VIDEO_BUTTON = "videoUploadModalCustomVideo";
const SETTINGS_MODAL = {
  ALLOW_DOWNALOD_TOGGLE: "videoDownloadToggle",
  SPOILER_TOGGLE: "videoSpoilerToggle"
};

export { ADD_CUSTOM_VIDEO_BUTTON, ADD_URL_MODAL, ADD_URL_MODAL_INPUT, ADD_URL_MODAL_SUBMIT, ROOT, SETTINGS_MODAL };
//# sourceMappingURL=dataHooks.js.map
